import React from "react";
import { useUser } from "../utils/AccountStore";

const Profile = () => {
    const { user } = useUser();

    return (
        <div className="flex flex-col gap-2">
            <div className="flex flex-row gap-2 items-center">
                <div>
                    <strong className="text-gray-900 dark:text-gray-100">{user?.displayName}</strong>
                    <p className="text-gray-600 dark:text-gray-400">{user?.email}</p>
                </div>
            </div>
            <div className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800">
                <div className="flex flex-row gap-2 items-center flex-wrap">
                    <strong className="text-gray-900 dark:text-gray-100">Claims:</strong>
                    {user?.claims?.map((claim, index) => (
                        <div key={index} className="p-1 rounded-lg bg-gray-200 dark:bg-gray-700 text-sm">
                            <span className="text-gray-800 dark:text-gray-200">{claim.type}:</span>{" "}
                            <span className="text-gray-600 dark:text-gray-400">{claim.value}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Profile;
